// store/index.ts
import { configureStore } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import { authReducer } from './auth';
import { authPersistConfig } from './auth/persistConfig';
import { briefingsReducer } from './briefings';
import { categoriesReducer } from './categories';
import { companiesReducer } from './companies';
import { contactReducer } from './contact';
import { dataReducer } from './data';
import { financialsReducer } from './financials';
import snackbarReducer from './snakebar/slice';
import { studiesReducer } from './studies';
import { studiesPersistConfig } from './studies/persistConfig';
import { studyYearsReducer } from './study-year';
import { studyYearsPersistConfig } from './study-year/persistConfig';
import { studyYearCategoriesReducer } from './study-year-categories';
import { studyYearCategoryCompaniesReducer } from './study-year-category-companies';
import { studyYearCompaniesReducer } from './study-year-companies';
import { userReducer } from './user';

export const store = configureStore({
  reducer: {
    auth: persistReducer(authPersistConfig, authReducer),
    briefings: briefingsReducer,
    companies: companiesReducer,
    contact: contactReducer,
    data: dataReducer,
    financials: financialsReducer,
    snackbar: snackbarReducer,
    studies: persistReducer(studiesPersistConfig, studiesReducer),
    studyYears: persistReducer(studyYearsPersistConfig, studyYearsReducer),
    studyYearCategories: studyYearCategoriesReducer,
    studyYearCategoryCompanies: studyYearCategoryCompaniesReducer,
    studyYearCompanies: studyYearCompaniesReducer,
    user: userReducer,
    categories: categoriesReducer,
    // other reducers
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const persistor = persistStore(store);
